import { useEffect, useState } from "react";
import type { DashboardApi } from "./api.js";

/** The installation belongs to GitHub; this page only requests a refresh afterward. */
export function RepositoryAccess({ api, onRefresh }: { api: DashboardApi; onRefresh(): Promise<void> }) {
  const [installUrl, setInstallUrl] = useState<string | null>(null);
  const [working, setWorking] = useState(false);
  const [notice, setNotice] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    void api.githubAvailability().then((result) => { if (!cancelled) setInstallUrl(result.installUrl ?? null); }).catch(() => undefined);
    return () => { cancelled = true; };
  }, [api]);
  async function refresh() {
    setWorking(true); setNotice(null);
    try {
      await api.githubSync();
      await onRefresh();
      setNotice("GitHub sync requested. If the repository is still missing, refresh again in a moment.");
    } catch (caught) { setNotice(caught instanceof Error ? caught.message : "Could not refresh repositories."); }
    finally { setWorking(false); }
  }
  return <details className="connect-optional">
    <summary>Missing a repository?</summary>
    <p className="muted compact">Give the Baton GitHub App access to the repository, then refresh this list.</p>
    {installUrl && <p><a href={installUrl} target="_blank" rel="noreferrer">Connect repositories on GitHub</a></p>}
    <button type="button" className="sidebar-button" disabled={working} onClick={() => void refresh()}>{working ? "Refreshing…" : "Refresh repositories"}</button>
    {notice && <p role="status" className="muted compact">{notice}</p>}
  </details>;
}
